import { Button, Col, Container, Row } from "react-bootstrap";
import { useStore } from "../../stores/store";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { PagingParams } from "../../models/pagination";
import AdminNav from "./adminNav";

export default observer(function AllInputs() {

    const { commonStore, userStore, adminStore } = useStore();
    const { adminInputs, setPagingParams, pagination } = adminStore;
    const [loadingNext, setLoadingNext] = useState(false);

    function handleGetNext() {

        setLoadingNext(true);

        setPagingParams(new PagingParams(pagination!.currentPage + 1));

        adminStore.getAllInputs().then(() => setLoadingNext(false));

    }

    useEffect(() => {
        if (commonStore.token) {
            userStore.getUser().finally(() => commonStore.setAppLoaded());
        } else {
            commonStore.setAppLoaded()
        }

        adminStore.getAllInputs();

    }, [commonStore, userStore, adminStore]);

    return (
        <>
            {userStore.isLoggedIn ? (
                <Container>
                    <Row className='mb-3'>
                        <AdminNav />
                    </Row>
                    <Row>
                        <Col lg={12}><h1>All Inputs</h1></Col>
                    </Row>
                    <Row>
                        <Col lg={1}><h4>Index</h4></Col>
                        <Col lg={3}><h4>Prompt</h4></Col>
                        <Col lg={3}><h4>Input text</h4></Col>
                        <Col lg={3}><h4>Output text</h4></Col>
                        <Col lg={1}><h4>Usage date</h4></Col>
                        <Col lg={1}><h4>Total Tokens</h4></Col>
                    </Row>
                    <Row>
                        <Col lg={12}>

                            {adminInputs && adminInputs.map((p, ind) => (
                                <Row>
                                    <Col lg={1}><p>{pagination != null ? pagination.totalItems - ind : 0}</p></Col>
                                    <Col lg={3}><p>{p.promptText}</p></Col>
                                    <Col lg={3}><p>{p.rawInput.text}</p></Col>
                                    <Col lg={3}><p>{p.rawOutput.outputText}</p></Col>
                                    <Col lg={1}><p>{p.date}</p></Col>
                                    <Col lg={1}><p>{p.totalTokens}</p></Col>
                                </Row>
                            ))}

                        </Col>
                    </Row>
                    <Row className='mb-5'>
                        <Col lg={4}>
                            <Button variant='success' onClick={handleGetNext} disabled={pagination?.currentPage === pagination?.totalPages}>
                                {loadingNext ? 'Loading...' : "Get Next"}
                            </Button>
                        </Col>
                        <Col></Col>
                    </Row>
                </Container>) :
                (
                    <Container><h1>Not logged in</h1></Container>
                )}
        </>

    )
})